import { SortingTypeEnum } from '@shared';
import { SortingColumn } from './sorting-column';

export class SortingStatus {
	public sortDirection: SortingTypeEnum;
	public selectedColumn: SortingColumn;

	public constructor(status: Required<SortingStatus>) {
		this.sortDirection = status.sortDirection;
		this.selectedColumn = status.selectedColumn;
	}
}
